module.exports = __webpack_public_path__ + "static/dash-bg-bc4034514c0740904e44b272aa67d7a2.png";